export class GoogleWorkspaceGroupRestoreWorkload {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "GoogleWorkspaceGroupRestoreWorkloadType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceGroupRestoreWorkload.attributeTypeMap;
    }
    constructor() {
    }
}
